import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts'
import { UserStoreConfig } from './types'

export const createUserManagerSettings = (
  config: UserStoreConfig,
  storage: Storage,
  origin: string,
): UserManagerSettings => ({
  authority: config.auth0ServiceUrl,
  client_id: config.auth0ClientId,
  redirect_uri: `${origin}/auth-callback`,
  silent_redirect_uri: `${origin}/silent-renew`,
  post_logout_redirect_uri: `${origin}/`,
  response_type: 'code',
  scope: 'openid email idt prf dd offline_access',
  automaticSilentRenew: true,
  loadUserInfo: true,
  userStore: new WebStorageStateStore({
    prefix: 'oxford-',
    store: storage,
  }),
  extraQueryParams: {
    audience: 'https://cinch.co.uk',
    nx: 'true',
  },
  metadata: {
    end_session_endpoint: `${
      config.auth0ServiceUrl
    }/v2/logout?${new URLSearchParams({
      client_id: config.auth0ClientId,
      returnTo: `${origin}/logout-callback`,
    }).toString()}`,
    authorization_endpoint: `${config.auth0ServiceUrl}/authorize`,
    issuer: `${config.auth0ServiceUrl}/`,
    jwks_uri: `${config.auth0ServiceUrl}/.well-known/jwks.json`,
    userinfo_endpoint: `${config.auth0ServiceUrl}/userinfo`,
    token_endpoint: `${config.auth0ServiceUrl}/oauth/token`,
    registration_endpoint: `${config.auth0ServiceUrl}/oidc/register`,
    revocation_endpoint: `${config.auth0ServiceUrl}/oauth/revoke`,
    scopes_supported: [
      'openid',
      'profile',
      'offline_access',
      'name',
      'given_name',
      'family_name',
      'nickname',
      'email',
      'email_verified',
      'picture',
      'created_at',
      'identities',
      'phone',
      'address',
    ],
    response_types_supported: [
      'code',
      'token',
      'id_token',
      'code token',
      'code id_token',
      'token id_token',
      'code token id_token',
    ],
    code_challenge_methods_supported: ['S256', 'plain'],
    response_modes_supported: ['query', 'fragment', 'form_post'],
    subject_types_supported: ['public'],
    token_endpoint_auth_signing_alg_values_supported: ['HS256', 'RS256'],
    token_endpoint_auth_methods_supported: [
      'client_secret_basic',
      'client_secret_post',
    ],
    claims_supported: [
      'aud',
      'auth_time',
      'created_at',
      'email',
      'email_verified',
      'exp',
      'family_name',
      'given_name',
      'iat',
      'identities',
      'iss',
      'name',
      'nickname',
      'phone_number',
      'picture',
      'sub',
    ],
  },
})
